import Location from "./location";

export interface IContractSignature {
  id: string;
  contract_moving_out_id: string;
  zip_code: string;
  exact_address: string;
  phone: string;
  bank_account_information: string;
  singer_type: number;
  approval_items: number[];
  sign_image_id: string;
}
export class ContractSignatureDTO implements IContractSignature {
  id: string;
  contract_moving_out_id: string;
  zip_code: string;
  exact_address: string;
  phone: string;
  bank_account_information: string;
  singer_type: number;
  approval_items: number[];
  sign_image_id: string;
  location: Location;
}

export default class ContractSignature extends ContractSignatureDTO {
  re_sign = false;
  constructor(dto?: ContractSignatureDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      dto.location && (this.location = new Location(dto.location));
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      contract_moving_out_id: null,
      zip_code: null,
      exact_address: null,
      phone: null,
      bank_account_information: null,
      singer_type: 1,
      approval_items: [],
      sign_image_id: null,
      location: new Location(),
    });
  }
}
